const pickValue = (...values: Array<string | undefined>) => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim().length > 0) {
      return value.trim();
    }
  }
  return '';
};

export const POLICY_LAST_UPDATED = '2026-03-28';
export const COOKIE_CONSENT_STORAGE_KEY = 'ny_cookie_consent';
export const OPEN_COOKIE_SETTINGS_EVENT = 'ny-open-cookie-settings';
export type AnalyticsConsent = 'granted' | 'denied' | 'unset';

export const COMPLIANCE_CONFIG = {
  contactEmail: pickValue(import.meta.env.VITE_COMPLIANCE_CONTACT_EMAIL, 'lsbbb9797@gmail.com'),
  analyticsRetentionPeriod: pickValue(
    import.meta.env.VITE_COMPLIANCE_ANALYTICS_RETENTION,
    '관련 법령과 서비스 운영 목적을 충족하는 동안',
  ),
  overseasCountry: pickValue(
    import.meta.env.VITE_COMPLIANCE_OVERSEAS_COUNTRY,
    '미국, 아일랜드 등 분석 서비스 운영 지역',
  ),
  overseasRecipient: pickValue(
    import.meta.env.VITE_COMPLIANCE_OVERSEAS_RECIPIENT,
    'Google LLC, Microsoft Corporation 등 서비스 운영에 필요한 수탁업체',
  ),
  gaMeasurementId: pickValue(import.meta.env.VITE_GA_MEASUREMENT_ID),
  clarityProjectId: pickValue(import.meta.env.VITE_CLARITY_PROJECT_ID),
} as const;

export const isConfiguredEmail = COMPLIANCE_CONFIG.contactEmail.length > 0;
